import gql from 'graphql-tag';
import { useQuery, provideApolloClient } from '@vue/apollo-composable';
import { reactive, watch, ref } from 'vue';
import useDecryptSymbols from './useDecryptSymbols';
import useAlerts from './useAlerts';
import apolloClient from './useApolloClient';

const { decryptSymbols } = useDecryptSymbols();
const { addAlert } = useAlerts();

const showSingleLead = ref(null);
const lead = reactive({});
const loadingLead = ref(false);

const GET_LEAD = gql`
  query LeadQuery($leadId: ID!) {
    lead(id: $leadId) {
      LEADID
      ASSIGNEDID
      NAME
      NOTES
      BWQUOTE
      CREATEDATE
      JOBNAME
      SOURCE
      LINKMETHOD
      COMPLETE
      INVNUM
      AMOUNT
      COMPLETEDATE
      COMPANYID
      CONTACTID
      HASDELIVERY
      DELIVERYADDRESS
      DELIVERYDATE
      GATECODE
      CHANNEL
      ALERTDELAY
      DELIVERYNOTES
      QUOTESUMMARY
      QUOTEDETAILS
      SCORE
      address {
        LINE1
        LINE2
        CITY
        STATE
        POSTALCODE
      }
      email {
        ADDRESS
      }
      phones {
        NUMBERDISPLAY
        TYPEID
        EXT
      }
      interactions {
        INTERACTIONID
        DATE
        NOTE
        TYPE
        SALESPERSONID
      }
      company {
        NAME
        address {
          LINE1
          LINE2
          CITY
          STATE
          POSTALCODE
        }
        phones {
          NUMBERDISPLAY
          TYPEID
          EXT
        }
      }
      contact {
        FIRSTNAME
        LASTNAME
        address {
          LINE1
          LINE2
          CITY
          STATE
          POSTALCODE
        }
        company {
          NAME
        }
        email {
          ADDRESS
        }
        phones {
          NUMBERDISPLAY
          EXT
          TYPEID
        }
      }
    }
  }
`;

const useLeadQuery = function (leadid) {
  provideApolloClient(apolloClient);

  const { result, error, loading } = useQuery(GET_LEAD, { leadId: leadid }, { fetchPolicy: 'no-cache' });

  loadingLead.value = loading;

  watch(result, () => {
    if (result.value) {
      lead.value = decryptSymbols(result.value?.lead);
    }
  });

  watch(error, () => {
    if (error.value) {
      console.error('Error fetching lead:', error.value);
      addAlert('Error fetching lead', 'high', 4);
    }
  });
};

watch(showSingleLead, (newValue) => {
  if (newValue) {
    useLeadQuery(newValue);
  }
});

export default {
  showSingleLead,
  loadingLead,
  lead,
};
